import React, { FunctionComponent, ReactNode } from "react";
import { useTranslate } from "../../helpers";
import { HelpDrawerWrapper } from "..";
import { newBasicHelperDrawerAnalytics } from "../BasicHelperDrawerAnalytics";
import { AppContext } from "../../app/store";
import classNames from "classnames";

interface PharmacyNetworkLabelHelpDrawerProps {
  toggleText: ReactNode;
  toggleClassName?: string;
  analyticText: string;
}
export const PharmacyNetworkLabelHelpDrawer: FunctionComponent<PharmacyNetworkLabelHelpDrawerProps> = ({
  toggleText,
  toggleClassName,
  analyticText,
}) => {
  const t = useTranslate();
  const { dispatch } = React.useContext(AppContext);
  const pharmacyNetworkLabelHelperDrawerAnalytics = newBasicHelperDrawerAnalytics(
    {
      clickText: analyticText,
      dispatch,
    }
  );

  const createTermDefinition = (termId: string, definitionId: string) => {
    return (
      <li>
        <dfn
          role="term"
          className="ds-u-font-weight--bold ds-u-font-style--normal"
        >
          {t(termId)}
        </dfn>
        : <span role="definition">{t(definitionId)}</span>
      </li>
    );
  };

  return (
    <HelpDrawerWrapper
      toggleClassName={classNames(
        "ds-u-margin-bottom--3 ds-u-lg-margin-bottom--0 mct-hide-print",
        toggleClassName
      )}
      toggleText={toggleText}
      drawerTitle={t("pharmacy_network_label.help_drawer.title")}
      mctAnalytics={pharmacyNetworkLabelHelperDrawerAnalytics}
    >
      <div>
        <p>{t("pharmacy_network_label.help_drawer.intro_text")}</p>
        <ol>
          {createTermDefinition(
            "pharmacy.terms.preferred_network",
            "pharmacy_network_label.help_drawer.preferred_in_network"
          )}
          {createTermDefinition(
            "pharmacy.terms.in_network",
            "pharmacy_network_label.help_drawer.in_network"
          )}
          {createTermDefinition(
            "pharmacy.terms.out_of_network",
            "pharmacy_network_label.help_drawer.out_of_network"
          )}
          {createTermDefinition(
            "pharmacy.terms.mail_order",
            "pharmacy_network_label.help_drawer.mail_order"
          )}
        </ol>
      </div>
    </HelpDrawerWrapper>
  );
};
